"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _shipper = require("@/api/shipper");
var _vuePropertyDecorator = require("vue-property-decorator");
var TourForm = /*#__PURE__*/function (_Vue) {
  function TourForm() {
    var _this;
    (0, _classCallCheck2.default)(this, TourForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, TourForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "shippers", []);
    (0, _defineProperty2.default)(_this, "rules", {
      moneyReceive: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      shipperIds: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    return _this;
  }
  (0, _inherits2.default)(TourForm, _Vue);
  return (0, _createClass2.default)(TourForm, [{
    key: "watchMoneyReceive",
    value: function watchMoneyReceive(val) {
      this.$set(this.form, "moneyReturnCustomer", val.moneyReceive - this.form.moneyReturnShop);
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchShipper();
    }
  }, {
    key: "fetchShipper",
    value: function () {
      var _fetchShipper = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _shipper.shipperApi.findAll({
                isBlock: false
              });
            case 2:
              res = _context.sent;
              this.shippers = res.data.shippers;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchShipper() {
        return _fetchShipper.apply(this, arguments);
      }
      return fetchShipper;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], TourForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form", {
  immediate: true,
  deep: true
})], TourForm.prototype, "watchMoneyReceive", null);
TourForm = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], TourForm);
var _default = exports.default = TourForm;